/* eslint-disable no-unused-vars */

import { mockRequest } from '../util/request';

function getDefaultWarrant() {
  return {
    id: 0,
    number: 'string',
    isOwner: true,
    isSubstitution: true,
    providedTitle: 'providedTitle',
    dedicatedTitle: 'dedicatedTitle',
    status: {
      code: 'string',
      name: 'string',
    },
    action: ['edit', 'revoke', 'confirm', 'delete'],
    registrationDate: '2021-02-02',
    revokeDate: '2021-02-02',
    validFrom: '2021-02-02',
    validTo: '2021-02-02',
    reason: 'string',
    attachedFile: [
      {
        id: 0,
        filename: 'string',
        mimeType: 'string',
        fileSize: 'string',
      },
    ],
    authorized: {
      institution: {
        id: 0,
        name: 'string',
        address: {
          fullAddress: 'string',
          country: {
            code: 'string',
            name: 'string',
          },
          municipality: {
            code: 0,
            name: 'string',
          },
          region: {
            code: 0,
            name: 'string',
          },
          city: {
            code: 0,
            name: 'string',
          },
          street: {
            code: 0,
            name: 'string',
          },
          building: 'string',
          housing: 'string',
          room: 'string',
          postalCode: 'string',
        },
        code: 'string',
        vatCode: 'string',
        email: 'string',
        phone: 'string',
        site: 'string',
      },
      profile: {
        profileId: 0,
        type: 'string',
        title: 'string',
        firstname: 'string',
        lastname: 'string',
        institution: {
          id: 0,
          name: 'string',
          address: {
            fullAddress: 'string',
            country: {
              code: 'string',
              name: 'string',
            },
            municipality: {
              code: 0,
              name: 'string',
            },
            region: {
              code: 0,
              name: 'string',
            },
            city: {
              code: 0,
              name: 'string',
            },
            street: {
              code: 0,
              name: 'string',
            },
            building: 'string',
            housing: 'string',
            room: 'string',
            postalCode: 'string',
          },
          code: 'string',
          vatCode: 'string',
          email: 'string',
          phone: 'string',
          site: 'string',
        },
        qualification: [
          {
            type: {
              code: 'string',
              name: 'string',
            },
            regNumber: 'string',
            additionalInfo: 'string',
          },
        ],
        position: {
          code: 'string',
          name: 'string',
        },
      },
    },
    warrantScope: [
      {
        eptpSystem: {
          code: 'string',
          name: 'string',
        },
        resource: {
          code: 'string',
          name: 'string',
          description: 'string',
          type: {
            code: 'string',
            name: 'string',
          },
        },
        canRead: true,
        canWrite: true,
      },
    ],
    role: [
      {
        code: 'string',
        name: 'string',
      },
      {
        code: '2',
        name: 'second',
      },
      {
        code: '3',
        name: 'third',
      },
    ],
    grantedRole: [
      {
        code: '1',
        name: 'first',
      },
    ],
  };
}

const mockWarrantService = {
  getList(params) {
    return mockRequest({
      total: 0,
      page: 0,
      pageSize: 0,
      isSubstitution: true,
      warrantData: [
        {
          id: 'string',
          isOwner: true,
          number: 'string',
          status: {
            code: 'string',
            name: 'string',
          },
          isLimited: true,
          profile: 'string',
          registrationDate: '2021-02-02',
          validFrom: '2021-02-02',
          validTo: '2021-02-02',
        },
      ],
    });
  },

  confirm(warrantId) {
    return mockRequest(getDefaultWarrant());
  },

  delete(warrantIds) {
    return mockRequest({
      warrantId: warrantIds,
    });
  },

  cancel(warrantId) {
    return mockRequest({
      warrantId,
    });
  },

  getById(id) {
    return mockRequest(getDefaultWarrant());
  },

  init() {
    return mockRequest({
      warrantId: 0,
    });
  },

  // params: eptpSystem, type, query
  getResourceList(params) {
    return mockRequest({
      warrantResource: [
        {
          code: 'string',
          name: 'string',
          description: 'string',
          type: {
            code: 'string',
            name: 'string',
          },
        },
      ],
    });
  },

  update(warrant) {
    if (warrant.reason === 'error') {
      return mockRequest(
        {
          error: [
            {
              code: '0',
              field: 'validFrom',
              message: 'Is required',
            },
            {
              code: '0',
              field: '',
              message: 'Is invalid',
            },
            {
              code: '0',
              field: 'roles',
              message: 'Select at least 2',
            },
          ],
        },
        400
      );
    }
    return mockRequest(getDefaultWarrant());
  },

  getAttachment(warrantId, attachmentId) {
    return mockRequest('');
  },

  createAttachment(warrantId, file) {
    return mockRequest({
      id: 0,
      filename: file.name,
      mimeType: 'string',
      fileSize: 'string',
    });
  },

  deleteAttachment(warrantId, attachmentId) {
    return mockRequest({
      id: 0,
      filename: 'string',
      mimeType: 'string',
      fileSize: 'string',
    });
  },
};

export default mockWarrantService;
